import * as React from 'react';

function SvgLayoutSidebarReverse(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M16 3a2 2 0 00-2-2H2a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V3zm-5-1v12H2a1 1 0 01-1-1V3a1 1 0 011-1h9zm1 0h2a1 1 0 011 1v10a1 1 0 01-1 1h-2V2z' />
		</svg>
	);
}

export default SvgLayoutSidebarReverse;
